// src/components/DashboardCards/FourCardGrid.js
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../pages/DashboardOverview.module.css';
import NewListingBg from '../../assets/dashboard_assets/new_listing.png';
import ExistingListingBg from '../../assets/dashboard_assets/existing_listing.png';
import DealTagBg from '../../assets/dashboard_assets/deal_tag.png';
import ListingScoreBg from '../../assets/dashboard_assets/listing_score.png';
import AuthContext from '../../context/AuthContext';
import { useAmazonStatus } from '../../hooks/useAmazonStatus';
import ConnectAmazonModal from '../UI/ConnectAmazonModal';

const DashboardButtonCard = ({ title, description, onClick, isActive = true, smallText, largeText, backgroundImage, cardRef }) => {
  const cardClasses = `${styles.toolCard} ${!isActive ? styles.inactiveCard : ''} ${backgroundImage ? styles.cardWithBg : ''}`;
  const handleClick = isActive ? onClick : undefined;
  const cardStyle = backgroundImage ? {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: '150%',
    backgroundPosition: '35% center',
    backgroundRepeat: 'no-repeat'
  } : {};

  return (
    <button ref={cardRef} className={cardClasses} onClick={handleClick} disabled={!isActive} style={cardStyle}>
      {backgroundImage && <div className={styles.cardImageOverlay}></div>}
      {smallText && largeText ? (
        <>
          <p className={styles.cardSmallText}>{smallText}</p>
          <h3 className={styles.cardTitle}>{largeText}</h3>
        </>
      ) : (
        <h3 className={styles.cardTitle}>{title}</h3>
      )}
      {description && <p className={styles.cardDescription}>{description}</p>}
    </button>
  );
};

const FourCardGrid = ({
  setIsNewListingMode,
  setModalInitialType,
  setIsCreateListingModalOpen,
  handleUpgradeExistingListing,
  existingListingCardRef
}) => {
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const { connected: amazonConnected } = useAmazonStatus(authCtx.token);
  const [showConnectModal, setShowConnectModal] = useState(false);

  const isClosedWithoutAmazon = authCtx.user?.account_type === 'close' && !amazonConnected;

  return (
    <div className={styles.fourCardGrid}>
      {/* Create a New Listing Card */}
      <DashboardButtonCard
        smallText="Create a"
        largeText="New Listing"
        onClick={() => {
          if (isClosedWithoutAmazon) {
            setShowConnectModal(true);
            return;
          }
          // From dashboard card - skip to Single/Bulk directly (skip New/Existing step)
          setIsNewListingMode(true);
          setModalInitialType('new'); // Set initial type to skip first step
          setIsCreateListingModalOpen(true);
        }}
        isActive={true}
        backgroundImage={NewListingBg}
      />

      {/* Upgrade your Existing Listing Card */}
      <DashboardButtonCard
        cardRef={existingListingCardRef}
        smallText="Upgrade your"
        largeText="Existing Listing"
        onClick={() => {
          if (isClosedWithoutAmazon) {
            setShowConnectModal(true);
            return;
          }
          handleUpgradeExistingListing();
        }}
        isActive={true}
        backgroundImage={ExistingListingBg}
      />
      
      {/* Validate the Deal tag Card (visible but disabled) */}
      <DashboardButtonCard
        smallText="Validate the"
        largeText="Deal tag"
        onClick={() => navigate('/dashboard/tools/check-deal-tags')}
        isActive={true}
        backgroundImage={DealTagBg}
      />
      
      {/* Check your Listing Score Card */}
      <DashboardButtonCard
        smallText="Check your"
        largeText="Listing Score"
        onClick={() => navigate('/dashboard/listing-score')}
        isActive={true}
        backgroundImage={ListingScoreBg}
      />
      <ConnectAmazonModal
        isOpen={showConnectModal}
        onClose={() => setShowConnectModal(false)}
      />
    </div>
  );
};

export default FourCardGrid;

